export const userId = (state) => {
  console.log('get uid', state)
  console.log('get uid2', state.beforLoginInfo)
  return state.beforLoginInfo.userId ?? ''
}

export const password = (state) => {
  return state.beforLoginInfo.password ?? ''
}

export const kaishaCd = (state) => {
  return state.beforLoginInfo.kaishaCd ?? ''
}

export const usanaviKokyakuCd = (state) => {
  return state.beforLoginInfo.usanaviKokyakuCd ?? ''
}
